import { observable } from 'mobx'
import { unixEpoch } from '@/utils/date-util'
import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { collection } from '@/infra/collection'
import { SkillTag, type SkillTagProps } from './SkillTag'

export interface SkillProps extends Omit<ModelProps<Skill>, 'tags'> {
  tags?: Partial<SkillTagProps>[]
}

export class Skill extends Model<Skill> {
  id = Id.none
  @observable accessor name = ''
  @observable accessor description = ''
  @observable accessor workspaceId = Id.none
  @observable accessor dateCreated: Date = unixEpoch()
  @observable accessor dateModified: Date = unixEpoch()
  readonly tags = collection({
    getDataId: (data) => data.id,
    getModelId: (model) => model.id,
    create: () => new SkillTag(),
  })

  override set({ tags, ...props }: Partial<SkillProps>): this {
    this.tags.reset(tags)
    return super.set(props)
  }
}
